export const motive = {
    methods: {
        getMotivePath(contractId, isChecklist) {
            // default motive
            let motive = "allgemein";
            if (isChecklist) {
                motive = "wohnen";
            } else if (
                contractId !== "" &&
                "Motives" in this.$store.state.contracts[contractId]
            ) {
                let motives = this.$store.state.contracts[contractId].Motives;
                let motiveKey = Object.keys(motives)[0];
                let motiveValue = motives[motiveKey];
                let motivesConfig = this.$store.state.motivesConfig;
                for (let motiveConfigKey in motivesConfig) {
                    if (motiveValue === motivesConfig[motiveConfigKey].motive) {
                        motive = motivesConfig[motiveConfigKey].path;
                        break;
                    }
                }
            }
            return motive;
        },
    },
};
